import React, {Component} from "react"
import {Link} from "react-router-dom"
import {Button, Loader, Table} from "semantic-ui-react"
import PropTypes from "prop-types"
import _ from "lodash"
import shop from "shop/shop"
import moment from "moment"

import Price from "components/Price/Price"

class AccountOrderDetailPage extends Component {
	state = {
		order  : false,
		orderId: false
	}

	constructor( props ) {
		super()
		console.log( `new order page`, props, {orderId: props.match.params.orderId} )
		if ( props && props.match.params && props.match.params.orderId ) {
			this.loadOrder( props.match.params.orderId )
			this.setState( {orderId: props.match.params.orderId} )
		}
	}

	async loadOrder( orderId ) {
		const order = await this.getSelectedOrder( orderId )
		this.setState( {order} )
	}

	render() {
		const {order} = this.state
		const {backOrderMode} = this.props.match.params
		console.log( {backOrderMode} )
		if ( !order ) return (
			<div>
				<Loader active />
			</div>
		)


		return (
			<div className="container pt4">
				<div className="pb3"><Button as={Link} size={"small"} basic to="/account">{translate( "zurück zum Konto" )}</Button></div>
				<h1>
					{backOrderMode && <div>{translate( "Rückstellungen" )} #{order.map_id}</div>}
					{!backOrderMode && <div>{translate( "Bestellung" )} #{order.map_id}</div>}
				</h1>


				{backOrderMode && <div>
					<Link className={"underline"} to={`/account/orders/${order.map_id}`}>{translate( "Alle Positionen anzeigen" )}</Link>
				</div>}

				<h3 className="mt4">{translate( "cart.positions" )}</h3>
				<div className="pb3">
					<OrderDetailTable filterBackorders={!!backOrderMode} products={order.positions} netto={order.netto} />
				</div>
				<p>
					<span className="ttu b">{translate( "shop.comment" )}: </span>
					{order.comment ? order.comment : "-"}
				</p>

				<p>
					<span className="ttu b">Erstellt am: </span>
					{moment( order.created )
						.format( "DD-MM-YYYY" )}
				</p>

				<p className="mt4">
					<small>
						<Link to="/account">
							<i className="icon icon-angle-left" />
							Zurück zur Konto-Übersicht
						</Link>
					</small>
				</p>
			</div>
		)
	}

	// TODO: Replace with actual API call. This "blackbox" exists so the actual
	// way to get the order is easily switchable.
	getSelectedOrder( orderId ) {
		return shop.fetch( "/shop/rest/data/orders?start=0&count=120&open=0" )
			.then( res => res.values )
			.then( orders => {
				let order = orders.filter( o => o.map_id == orderId )
				return _.first( order )
			} )
	}
}

const OrderDetailTable = ( {products, netto, filterBackorders} ) => {
	const filteredProducts = filterBackorders ? products.filter( p => p.open !== 0 ) : products
	return (
		<div className="table-scroller">
			<Table>
				<colgroup>
					<col width="10%" />
					<col width="40%" />
					<col width="20%" />
					<col width="20%" />
					<col width="10%" />
				</colgroup>

				<Table.Header>
					<tr>
						<th>{translate( "product.articlenr" )}</th>
						<th>{translate( "product.label" )}</th>
						<th className="tl">{translate( "product.amount" )}</th>
						<th className="tl">{translate( "shop.VE" )}</th>
						<th className="tr">{translate( "product.price" )}</th>
						<th className="tr"></th>
					</tr>
				</Table.Header>

				<Table.Body>


					{filteredProducts && filteredProducts.map( ( product, index ) => <OrderDetailRow key={index + "_" + product.map_id} product={product} /> )}

					<tr>
						<td className="tr" colSpan="5">
							<span className="ttu b">Netto:</span> <Price>{netto}</Price>
						</td>
					</tr>
				</Table.Body>
			</Table>
		</div>
	)
}

OrderDetailTable.propTypes = {
	products: PropTypes.array,
}

const OrderDetailRow = ( {product} ) => {

	return (
		<React.Fragment>
			<tr className={`${product.open !== 0 && "isOpenPosition"}`}>
				<td>{product.article_nr}</td>
				<td>
					<div>{product.desc}</div>
					<div className={""}>
						{product.open !== 0 && <div className={"blue"}>{translate( "Rückstellungen" )} <span className={"b blue"}>{product.open} </span></div>}
					</div>
				</td>
				<td className="tc">{product.count}</td>
				<td className="tl" title={product.unit_multi}>{Math.round( product.unit_multi )} {translate( "Stück" )}</td>
				<td className="tr"><Price>{product.sum}</Price></td>
				<td className="tr"><Button icon={"shopping cart"} onClick={async () => {
					const p = await shop.product( product.article_id )
					if ( p ) {
						p.count = 1
						shop.cart.add( p )
						shop.toast( translate( "Produkt hinzugefügt" ), "success", false, "bottom" )
					} else {
						shop.toast( translate( "Produkt nicht mehr verfügbar" ), "info", false, "bottom" )
					}
				}} /></td>
			</tr>
		</React.Fragment>
	)
}

OrderDetailTable.propTypes = {
	product: PropTypes.object,
}

export default (AccountOrderDetailPage)



// WEBPACK FOOTER //
// ./src/pages/AccountOrderDetailPage.js